import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CustomValidators } from '../shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-add-sociedad',
  templateUrl: './add-sociedad.component.html',
  styleUrls: ['./add-sociedad.component.css']
})
export class AddSociedadComponent implements OnInit {
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;

  constructor(
    private apiService: ApiService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (!language) language = 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalWeb: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^(https?:\/\/)?[\w\-]+(\.[\w\-]+)+[/#?]?.*$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        Validators.pattern(/^(?!.*(<|>|script|on\w+=|javascript:|data:text\/html|base64)).*$/i),
        CustomValidators.secureInput
      ])
    });
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalWeb() {
    return this.validatingForm.get('signupFormModalWeb');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  addSociedad() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_571'), this.translate.instant('texto_813'));
      return;
    }

    this.apiService.addSociedad(
      this.signupFormModalId.value,
      this.signupFormModalName.value,
      this.signupFormModalWeb.value,
      this.contactFormModalMessage.value
    ).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_569'), this.translate.instant('texto_572'));
        } else {
          this.toastr.error(this.translate.instant('texto_571'), this.translate.instant('texto_572'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['dashboard/layout/sociedades']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_571'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_571'), this.translate.instant('texto_813'));
        }
      })
  }

  hideModal() {
    this.IsHiddenForm = false;
  }
}
